import { useQuery } from "@tanstack/react-query";
import { getActiveLeaseInfo } from "~/services/browser";
import * as APITypes from "~/API";

export const useActiveLeaseInfo = ({
  unitID,
  ownerID,
  ownerType,
}: {
  unitID: string;
  ownerID: string;
  ownerType: APITypes.OwnerType;
}) => {
  const result = useQuery({
    queryKey: ["useActiveLeaseInfo", unitID],
      queryFn: () => getActiveLeaseInfo({ unitID, ownerID, ownerType }),
    staleTime: 5 * 1000,
    enabled: unitID !== "" && ownerID !== "",
  });
  return result;
};
